import * as React from 'react'
import {Icon} from 'antd';
import autobind from 'autobind-decorator';
import {resolve} from '../inversify.config';
import HttpService from '../core/services/http.service';

export interface FavoriteProps {
    isFavorite: boolean
    onChange?: (value: boolean) => void;
    projectId: string;
    companyId: string;
    employeeId: string;
    favoriteStatusChanged: (newValue: boolean) => void
}
export interface FavoriteState {
    isFavorite?: boolean,
    projectId: string,
    companyId: string,
    employeeId: string,
    isBusy?: boolean
}

export default class Favorite extends React.Component<FavoriteProps, FavoriteState> {
    constructor(props: FavoriteProps) {
        super(props);
        this.state = {
            isFavorite: this.props.isFavorite,
            companyId: this.props.companyId,
            employeeId: this.props.employeeId,
            projectId: this.props.projectId,
        }
    }

    @resolve(HttpService)
    private httpService!: HttpService;

    componentWillReceiveProps(nextProps: FavoriteProps) {
        this.setState(nextProps);
    }

    // toggle is Busy 
    @autobind
    public async toggleFavorite(e: React.MouseEvent) {
        const { isBusy } = this.state
        const { companyId, projectId, employeeId } = this.props
        if (!isBusy) {
            const isFavorite = !this.state.isFavorite;
            this.setState({
                isBusy: true,
            });
            try {
                await this.httpService.post<{ projectId: string, add: boolean }, boolean>(
                    `${process.env.PUBLIC_URL}/api/v1/companies/${companyId}/employees/${employeeId}/favorite-project`, { add: isFavorite, projectId });
                this.setState({ isBusy: false, isFavorite: isFavorite }, () => this.props.favoriteStatusChanged(isFavorite));
            } catch (_) {
                this.setState({
                    isBusy: false,
                });
            }
        }
    }

    render() {
        const { isFavorite, isBusy } = this.state;
        return (
            <Icon
                theme="filled"
                type="star"
                style={{ color: isFavorite ? "#fadb14" : "#B8BBC1" }}
                onClick={this.toggleFavorite}
                spin={isBusy}
            />
        );
    }
}